import type { ReactNode } from 'react'
import styles from './Checkbox.module.css'

type Props = {
	checked: boolean
	onChange: (next: boolean) => void
	disabled?: boolean
	// Needed when there are no children to name the box.
	ariaLabel?: string
	className?: string | undefined
	children?: ReactNode
}

// A custom box over a transparent native checkbox. Children render inside
// the same <label>, so tapping the text toggles it too.
export const Checkbox = ({
	checked,
	onChange,
	disabled = false,
	ariaLabel,
	className,
	children,
}: Props) => (
	<label className={`${styles.check} ${className ?? ''}`.trim()}>
		<span className={styles.control}>
			<input
				type="checkbox"
				checked={checked}
				disabled={disabled}
				onChange={(e) => onChange(e.target.checked)}
				aria-label={ariaLabel}
			/>
			<span className={styles.box} aria-hidden="true" />
		</span>
		{children}
	</label>
)
